import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import React from "react";
import strings from "../../config/localization";

// TODO: Remove Reports.tsx
export default function BandobastReportsPanel(props: any) {
  return (
    <div>
      <Box sx={{ height: 400, width: "100%" }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <a
              href={`/bandobast/reports/overview/${props.bandobastId}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Link color="primary" underline="hover">
                {strings.overview}
              </Link>
            </a>
          </Grid>
          <Grid item xs={12}>
            <a
              href={`/bandobast/reports/summary/${props.bandobastId}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Link color="primary" underline="hover">
                {strings.personnelAssessmentAllocationSummary}
              </Link>
            </a>
          </Grid>
          <Grid item xs={12}>
            <a
              href={`/bandobast/reports/assessmentReport/${props.bandobastId}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Link color="primary" underline="hover">
                {/* {strings.personnelAssessmentAllocationSummary} */}
                {'Personnel Assessment'}
              </Link>
            </a>
          </Grid>
          <Grid item xs={12}>
            <a
              href={`/bandobast/reports/allocationsReport/${props.bandobastId}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Link color="primary" underline="hover">
                {/* {strings.personnelAssessmentAllocationSummary} */}
                {'Personnel Allocation'}
              </Link>
            </a>
          </Grid>
          <Grid item xs={12}>
            <a
              href={`/bandobast/reports/allocationsPendingReport/${props.bandobastId}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Link color="primary" underline="hover">
                {/* {strings.personnelAssessmentAllocationSummary} */}
                {'Personnel Pending Allocation'}
              </Link>
            </a>
          </Grid>
          <Grid item xs={12}>
            <a
              href={`/bandobast/reports/resourceSummary/${props.bandobastId}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Link color="primary" underline="hover">
                {strings.resourceAssessmentAllocationSummary}
              </Link>
            </a>
          </Grid>
          <Grid item xs={12}>
            <a
              href={`/bandobast/reports/personnel/${props.bandobastId}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Link color="primary" underline="hover">
                {strings.personnelAllocation}
              </Link>
            </a>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
